module.exports = __webpack_public_path__ + "img/apple-pay.88421001.svg";